import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderSiteVisit from "../Components/SiteVisit/headerSiteVisit";
import SiteVisitList from "../Components/SiteVisit/siteVisitList";
import AgentSiteVisitList from "../Components/SiteVisit/agentSiteVisit";
import ViewSiteVisit from "../Components/SiteVisit/viewSiteVisit";
import ViewAgentSiteVisit from "../Components/SiteVisit/viewAgentSiteVisit";

const SiteVisitRoutes = () => {
  return (
    <Routes>
      <Route path="/site_visit" element={<HeaderSiteVisit />} />
      <Route path="/user_site_visit" element={<SiteVisitList />} />
      <Route path="/agent_site_visit" element={<AgentSiteVisitList />} />
      <Route path="/site-visit/:id" element={<ViewSiteVisit />} />
      <Route path="/agent-site-visit/:id" element={<ViewAgentSiteVisit />} />
    </Routes>
  );
};

export default SiteVisitRoutes;
